export class Responsive {
  ResponsiveDesign: boolean = true;
  TabletBreakpoint: number = 998;
  MobileBreakpoint: number = 578;
  HeaderMenuBreakpoint: number = 578;
}
